import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from "@angular/core";

@Component({
    selector: "app-widget-human-body",
    templateUrl: "./widget-human-body.component.html",
    styleUrls: ["./widget-human-body.component.scss"],
})
export class WidgetHumanBodyComponent implements AfterViewInit {
    @Input() public partID: string;
    @Input() public selectedparts: any [];
    public story: string;
    public circles = [];
    @Output() public selectStory = new EventEmitter<number>();

    public elemLeft: any;
    public elemTop: any;
    public canvasW: any;
    public canvasH: any;
    public cx: CanvasRenderingContext2D;
    public image: any;
    public clickedpartID: any;
    public clickedX: any;
    public clickedY: any;
    public pageX: any;
    public pageY: any;
    @ViewChild("canvas") public canvas: ElementRef;

    @ViewChild("humanBodys") public hitCanvas: ElementRef;

    public widgetLoaded: boolean = false;
    private arr: any = [];
    private count: number = 0;

    private _name = "";
    @Input()
    set name(name: string) {

        if (typeof name === "undefined") {

        } else {
            this.clickedpartID = "";
            this.loadWidget(this.clickedX, this.clickedY, true);

        }

    }

    get name(): string {
        return this._name;
    }

    public ngAfterViewInit(): void {

        setTimeout(() => {
            this.count = this.selectedparts.length;

            const that = this;
            /**/
            const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;

            this.cx = canvasEl.getContext("2d");
            this.image = new Image();

            this.canvasW = canvasEl.offsetWidth;
            this.canvasH = canvasEl.offsetHeight;

            this.image.onload = () => {
                this.cx.drawImage(this.image, 0, 0);
                const imgData = that.cx.getImageData(0, 0, that.canvasW, that.canvasH);
                that.contrastImage(imgData, 1);

            };
            this.image.src = "../assets/img/human.png";

            this.dataLoadHumanbody();

            this.canvas.nativeElement.addEventListener(
                "click",
                function (e) {
                    const x = $("#humanBody").offset();
                    /*   alert("Top: " + x.top + " Left: " + x.left);
                       alert( e.pageX + " - " + that.canvas.nativeElement.offsetLeft); /!*336 - 210*!/
                       alert( e.pageY + " - " + that.canvas.nativeElement.offsetTop); /!*126-108*!/*/

                    that.clickedX = e.pageX - x.left;
                    that.clickedY = e.pageY - x.top;

                    that.loadWidget(that.clickedX, that.clickedY);
                },
            );

        }, 0);

    }

    public loadWidget(clickedX, clickedY, load = false) {

        const that = this;
        $("#p p").hide();

        that.cx.clearRect(0, 0, that.canvasW, that.canvasH);
        that.drawImage();
        that.dataLoadHumanbody();
        /*    const allP = [];*/

        for (let i = 0; i < that.circles.length; i++) {

            if (clickedX > that.circles[i].left && clickedY > that.circles[i].top1 && clickedX < that.circles[i].right && clickedY < that.circles[i].bottom) {

                if (!load) {
                    that.onSelectStory(i + 1);
                    that.clickedpartID = i + 1;

                }

                that.dataLoadHumanbody();

                let x;

                if (!load) {
                    x = i;
                } else {
                    x = -1;
                }
                switch (x) {

                    case 0:

                        that.drawLine(149, 15, 270, 20);

                        break;
                    case 1:

                        that.drawLine(75, 122, 235, 20, 300, 19);
                        break;
                    case 2:

                        that.drawLine(182, 122, 235, 20, 300, 19);
                        break;
                    case 3:

                        that.drawLine(86, 555, 235, 20, 300, 19);
                        break;

                    case 4:

                        that.drawLine(182, 555, 235, 20, 300, 19);
                        break;

                    case 5:

                        that.drawLine(28, 318, 235, 20, 300, 19);
                        break;
                    case 6:

                        that.drawLine(229, 318, 235, 20, 300, 19);
                        break;
                    case 7:

                        that.drawLine(126, 150, 235, 20, 300, 19);
                        break;
                    case 8:

                        that.drawLine(100, 365, 235, 20, 300, 19);
                        break;
                    case 9:

                        that.drawLine(162, 365, 235, 20, 300, 19);
                        break;
                    case 10:

                        that.drawLine(100, 410, 235, 20, 300, 19);
                        break;
                    case 11:

                        that.drawLine(162, 410, 235, 20, 300, 19);
                        break;

                    case 12:

                        that.drawLine(95, 472, 235, 20, 300, 19);
                        break;

                    case 13:

                        that.drawLine(170, 472, 235, 20, 300, 19);
                        break;

                    case 14:

                        that.drawLine(53, 238, 235, 20, 300, 19);
                        break;
                    case 15:

                        that.drawLine(202, 238, 235, 20, 300, 19);
                        break;
                    case 16:

                        that.drawLine(147, 77, 235, 20, 300, 19);
                        break;
                    case 17:

                        that.drawLine(130, 270, 235, 20, 300, 19);
                        break;
                    case 18:

                        that.drawLine(125, 50, 235, 20, 300, 19);
                        break;
                    case 19:

                        that.drawLine(112, 39, 235, 20, 300, 19);
                        break;
                    case 20:

                        that.drawLine(138, 39, 235, 20, 300, 19);
                        break;
                    case 21:

                        that.drawLine(95, 49, 235, 20, 300, 19);
                        break;
                    case 22:

                        that.drawLine(158, 49, 235, 20, 300, 19);
                        break;
                    case 23:

                        that.drawLine(34, 304, 235, 20, 300, 19);
                        break;
                    case 24:

                        that.drawLine(224, 304, 235, 20, 300, 19);
                        break;
                    case 25:

                        that.drawLine(73, 226, 235, 20, 300, 19);
                        break;
                    case 26:

                        that.drawLine(184, 226, 235, 20, 300, 19);
                        break;
                    case 27:

                        that.drawLine(88, 520, 235, 20, 300, 19);
                        break;
                    case 28:

                        that.drawLine(164, 520, 235, 20, 300, 19);
                        break;
                    default:
                    // that.drawLine(190, 20, 270, 20);
                }

                if (!load) {
                    document.getElementById("p" + i).style.display = "block";
                }
                this.widgetLoaded = true;
                return;
            }

        }

    }

    public onSelectStory(story: number) {
        this.selectStory.emit(story);
    }

    public contrastImage(imageData, contrast) {  // contrast input as percent; range [-1..1]
        const data = imageData.data;  // Note: original dataset modified directly!
        contrast *= 255;
        const factor = (contrast + 255) / (255.01 - contrast);  //add .1 to avoid /0 error.

        for (let i = 0; i < data.length; i += 4) {
            data[i] = factor * (data[i] - 128) + 128;
            data[i + 1] = factor * (data[i + 1] - 128) + 128;
            data[i + 2] = factor * (data[i + 2] - 128) + 128;
        }
        return imageData;  //optional (e.g. for filter function chaining)
    }

    public drawImage() {
        this.cx.drawImage(this.image, 0, 0);
    }

    public drawLine(moveX, moveY, lineX1, lineY1, lineX2 = 0, lineY2 = 0) {
        this.cx.beginPath();
        this.cx.moveTo(moveX, moveY);
        this.cx.lineTo(lineX1, lineY1);
        if (lineX2 === 0 && lineY2 === 0) {

        } else {
            this.cx.lineTo(lineX2, lineY2);
        }
        this.cx.strokeStyle = "#8d8d8d";
        this.cx.stroke();
    }

    public circle(x, y, radius) {
        const person: any = [];
        person.left = x - radius;
        person.top1 = y - radius;
        person.right = x + radius;
        person.bottom = y + radius;
        return person;

    }

    public drawCircle(ctx, x, y, radius, id) {
        this.draw(this.cx, x, y, radius, id);

        const circleCtx = this.circle(x, y, radius);

        this.circles.push(circleCtx);

        this.cx.save();
    }

    public draw(ctx, x, y, radius, id) {
        const ids = id + 1;
        this.cx.beginPath();
        this.cx.arc(x, y, radius, 0, Math.PI * 2, true);
        this.cx.closePath();
        let color = "#ffb64c";
        if (this.selectedparts.includes(ids)) {
            color = "#ff0b0e";
        }
        if (ids === this.clickedpartID) {
            color = "#ff0b0e";

        }
        this.cx.fillStyle = color;
        this.cx.fill();

    }

    public dataLoadHumanbody() {
        this.drawCircle(this.cx, 149, 15, 5, 0);
        this.drawCircle(this.cx, 75, 122, 5, 1);
        this.drawCircle(this.cx, 182, 122, 5, 2);
        this.drawCircle(this.cx, 86, 555, 5, 3);
        this.drawCircle(this.cx, 182, 555, 5, 4);
        this.drawCircle(this.cx, 28, 318, 5, 5);
        this.drawCircle(this.cx, 229, 318, 5, 6);
        this.drawCircle(this.cx, 126, 150, 5, 7);
        this.drawCircle(this.cx, 100, 365, 5, 8);
        this.drawCircle(this.cx, 162, 365, 5, 9);
        this.drawCircle(this.cx, 100, 410, 5, 10);
        this.drawCircle(this.cx, 162, 410, 5, 11);
        this.drawCircle(this.cx, 95, 472, 5, 12);
        this.drawCircle(this.cx, 170, 472, 5, 13);
        this.drawCircle(this.cx, 54, 238, 5, 14);
        this.drawCircle(this.cx, 201, 238, 5, 15);
        this.drawCircle(this.cx, 147, 77, 5, 16);
        this.drawCircle(this.cx, 125, 270, 5, 17);
        this.drawCircle(this.cx, 125, 50, 5, 18);
        this.drawCircle(this.cx, 112, 39, 5, 19); /*Right Eye*/
        this.drawCircle(this.cx, 138, 39, 5, 20); /*Left Eye*/
        this.drawCircle(this.cx, 95, 49, 5, 21); /*Right Eear*/
        this.drawCircle(this.cx, 158, 49, 5, 22); /*Left Ear*/

        this.drawCircle(this.cx, 34, 304, 5, 23); /*Right Wrist*/
        this.drawCircle(this.cx, 224, 304, 5, 24); /*Left Wrist*/
        this.drawCircle(this.cx, 73, 226, 5, 25); /*Right Elbow*/
        this.drawCircle(this.cx, 184, 226, 5, 26); /*Left Elbow*/

        this.drawCircle(this.cx, 88, 520, 5, 27); /*Right Ankle*/
        this.drawCircle(this.cx, 164, 520, 5, 28); /*Left Ankle*/
    }

}



// WEBPACK FOOTER //
// /app/src/app/widget-human-body/widget-human-body.component.ts